export default __webpack_public_path__ + "assets/home.d3ed0b1c.jpg";